var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.showCalendar)?_c('div',[_c('Feed')],1):_vm._e(),(this.showCalendar)?_c('div',[_c('Calendar')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }